/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlannedYieldResponse } from '../../models/planned-yield-response';

export interface GetTodaysPlannedYield$Params {
  location_id: string;
}

export function getTodaysPlannedYield(http: HttpClient, rootUrl: string, params: GetTodaysPlannedYield$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedYieldResponse>> {
  const rb = new RequestBuilder(rootUrl, getTodaysPlannedYield.PATH, 'get');
  if (params) {
    rb.path('location_id', params.location_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlannedYieldResponse>;
    })
  );
}

getTodaysPlannedYield.PATH = '/locations/{location_id}/energy-forecasts/yield/today';
